import FlagRankPage from './FlagRankPage'
export default function TeamFlagsPage(){return <FlagRankPage detail />}
